import React, { createContext, useState } from "react";
import { ContextStatus } from '@leedpulse-monorepo/enums';
import getAllFavorite from "../../../domain/use_cases/favorites/getAllFavorites";
import { IContact } from '@leedpulse-monorepo/interfaces';

const FavoriteConversationsContext = createContext({
  items: [] as IContact[],
  count: 0,
  status: ContextStatus.IDLE,
  fetchFavorites: () => new Promise<void>((resolve, reject) => null),
  reset: () => {return;},
});

export const FavoriteConversationsProvider: React.FC<
  React.PropsWithChildren
> = ({ children }) => {
  const [items, setItems] = useState([] as IContact[]);
  const [count, setCount] = useState(0);
  const [status, setStatus] = useState(ContextStatus.IDLE);
  
  const fetchFavorites = async () => {
    setStatus(ContextStatus.LOADING);
    try {
      const favorites = await getAllFavorite();
      setItems(favorites);
      setCount(favorites.length);
      setStatus(ContextStatus.SUCCESS);
    } catch (error) {
      console.error("Erreur lors de la récupération des favoris :", error);
      setStatus(ContextStatus.ERROR);
    }
  };

  const reset = () => {
    setItems([]);
    setCount(0);
    setStatus(ContextStatus.IDLE);
  };

  return (
    <FavoriteConversationsContext.Provider
      value={{
        items,
        count,
        status,
        fetchFavorites,
        reset,
      }}
    >
      {children}
    </FavoriteConversationsContext.Provider>
  );
};

export default FavoriteConversationsContext;
